import { amplitudeEventsLib } from '..';

export type SpecialOfferFriendsParams = {
  source: 'main' | 'all_special_offers';
};

export const specialOfferFriendsShown = (params: SpecialOfferFriendsParams) => {
  amplitudeEventsLib.specialOfferFriendsShown(params);
};

export const specialOfferFriendsClicked = (
  params: SpecialOfferFriendsParams,
) => {
  amplitudeEventsLib.specialOfferFriendsClicked(params);
};
